import StockChart from '../modules/stock/stockChart';

class StockSection {
    constructor(el) {
        if (!this.set(el)) return;

        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.chart = this.root.querySelector('[data-stock-chart]');
        this.category = this.root.querySelectorAll(
            '[data-stock-section-category]'
        );
        this.tableEl = this.root.querySelector('[data-stock-section-table]');
        this.tableLoaderEl = this.root.querySelector(
            '[data-stock-section-table-loader]'
        );

        this.chartInstance = null;

        return true;
    }

    init() {
        this.setChart();
        this.setCategories();
        this.setTable();
    }

    async setTable() {
        if (!this.tableEl) return;

        const formData = new FormData();
        formData.append('action', 'get_table_stock_html');
        formData.append('lang', ajax.lang);
        this.tableLoaderEl.classList.remove('d-none');

        const req = await fetch(ajax.url, {
            method: 'POST',
            body: formData,
        });

        if (!req) return;
        const { html } = await req.json();
        this.tableEl.innerHTML = html;

        this.tableLoaderEl.classList.add('d-none');
    }

    setChart() {
        if (!this.chart) return;
        this.chartInstance = new StockChart(this.chart);
    }

    setCategories() {
        if (!this.category) return;

        this.onCategory = this.onCategoryClick.bind(this);
        this.category.forEach(item => {
            item.addEventListener('click', this.onCategory);
        });
    }

    onCategoryClick(event) {
        const { currentTarget } = event;
        const activeTabs = Array.from(this.category).filter(item =>
            item.classList.contains('-selected')
        );

        const chartAttr = parseInt(currentTarget.getAttribute('data-chart'));

        currentTarget.classList.toggle('-selected');
        if (activeTabs.length === 1) currentTarget.classList.add('-selected');

        this.chartInstance.setActiveGroup(chartAttr);
    }
}

const sections = document.querySelectorAll('[data-stock-section]');
const initStockSections = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new StockSection(el);
    });
};

initStockSections(sections);
